document.addEventListener("DOMContentLoaded", function () {
  // Initialize fabric selector groups
  initFabricSelectors();

  // Initialize zoom functionality for all groups
  initZoomFunctionality();
});

function initFabricSelectors() {
  // Get all unique fabric group IDs from data containers
  const groupIds = new Set();
  const dataContainers = document.querySelectorAll(".fabric-data-container");

  dataContainers.forEach((container) => {
    const groupId = container.getAttribute("data-group-id");
    if (groupId) {
      groupIds.add(groupId);
    }
  });

  // Initialize each group
  groupIds.forEach((groupId) => {
    initFabricGroup(groupId);
  });
}

function initFabricGroup(groupId) {
  // Get all data containers for this group
  const dataContainers = document.querySelectorAll(
    `.fabric-data-container[data-group-id="${groupId}"]`
  );
  if (!dataContainers.length) return;

  // Get the fabric popup elements for this group
  const popup = document.getElementById(`fabric-popup-${groupId}`);
  if (!popup) return;

  const closeBtn = document.querySelector(`[data-close-popup="${groupId}"]`);
  const confirmBtn = document.getElementById(`confirm-selection-${groupId}`);
  const stickyConfirmBtn = document.getElementById(
    `sticky-confirm-selection-${groupId}`
  );
  const fabricGroupsContainer = document.getElementById(
    `fabric-groups-container-${groupId}`
  );

  // Track the current selected fabric
  let currentSelectedFabric = "";
  let previousSelectedSwatch = null;

  // Fetch product data for prices
  let productData = null;
  fetchProductData(window.location.pathname + ".json")
    .then((data) => {
      productData = data;
    })
    .catch((error) => {
      console.error("Error loading product data:", error);
    });

  // Setup fabric data
  setupFabricGroupData(groupId, dataContainers, fabricGroupsContainer);

  // Initialize frame selection - check first radio button if none is selected
  const frameRadioButtons = document.querySelectorAll(
    'input[name="frame-selected"]'
  );
  if (frameRadioButtons.length > 0) {
    const checkedRadio = document.querySelector(
      'input[name="frame-selected"]:checked'
    );
    if (!checkedRadio && frameRadioButtons[0]) {
      frameRadioButtons[0].checked = true;
    }
  }

  // Add event listeners
  setupFabricSwatches(groupId, productData);

  let retryCount = 0;
  const maxRetries = 50;

  function initializeFabricSelection() {
    const fabricSelect = document.querySelector(
      'select.js-variant-selector[name*="Fabric"], select.js-variant-selector[data-fabric-select="true"]'
    );
    const frameSelect = document.querySelector(
      'select.js-variant-selector[name*="Frame"]'
    );
    if (fabricSelect && fabricSelect.options.length > 0) {
      checkAndSelectCurrentFabric(groupId);

      if (fabricSelect.value) {
        const selectedFrame = getSelectedFrame();
        updateFabricDisplaySelectorText(fabricSelect.value, selectedFrame);
      }
    } else if (retryCount < maxRetries) {
      retryCount++;
      requestAnimationFrame(initializeFabricSelection);
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(initializeFabricSelection);
      });
    });
  } else {
    requestAnimationFrame(() => {
      requestAnimationFrame(initializeFabricSelection);
    });
  }
  setupFabricTriggers(groupId, popup, productData);

  // Initialize sticky footer state (hidden by default)
  const stickyFooter = document.querySelector(".sticky-footer");
  if (stickyFooter) {
    stickyFooter.classList.remove("has-selection");
  }

  // Initialize confirm buttons as disabled
  if (confirmBtn) {
    confirmBtn.disabled = true;
  }
  if (stickyConfirmBtn) {
    stickyConfirmBtn.disabled = true;
  }

  // Add close button handler
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      popup.style.display = "none";
      document.body.style.overflow = "auto"; // Re-enable scrolling
      document.body.classList.remove("fabric-popup-open"); // Remove body class
    });
  }

  // Close popup when clicking outside
  window.addEventListener("click", function (event) {
    if (event.target === popup) {
      popup.style.display = "none";
      document.body.style.overflow = "auto"; // Re-enable scrolling
      document.body.classList.remove("fabric-popup-open"); // Remove body class
    }
  });

  // Add confirm button handler
  if (confirmBtn) {
    confirmBtn.addEventListener("click", function () {
      handleFabricConfirmation(
        groupId,
        currentSelectedFabric,
        popup,
        productData
      );
    });
  }

  // Add sticky confirm button handler
  if (stickyConfirmBtn) {
    stickyConfirmBtn.addEventListener("click", function () {
      handleFabricConfirmation(
        groupId,
        currentSelectedFabric,
        popup,
        productData
      );
    });
  }

  // Handle swatch clicks
  const fabricSwatches = document.querySelectorAll(
    `.fabric-swatch-button[data-group="${groupId}"]`
  );
  fabricSwatches.forEach((swatch) => {
    swatch.addEventListener("click", function () {
      const fabricName = this.getAttribute("data-name");
      const fabricMaterial = this.getAttribute("data-material") || "";
      const fabricImage = this.getAttribute("data-image");
      const fabricValue = this.getAttribute("data-fabric");
      const fabricThumbnail = this.getAttribute("data-thumbnail");
      // Update selected fabric display (main container)
      const selectedFabricName = document.getElementById(
        `selected-fabric-name-${groupId}`
      );
      const selectedFabricMaterial = document.getElementById(
        `selected-fabric-material-${groupId}`
      );
      const selectedFabricImage = document.getElementById(
        `selected-fabric-image-${groupId}`
      );

      // Update sticky footer elements
      const stickyFabricName = document.getElementById(
        `sticky-fabric-name-${groupId}`
      );
      const stickyFabricMaterial = document.getElementById(
        `sticky-fabric-material-${groupId}`
      );
      const stickyFabricImage = document.getElementById(
        `sticky-fabric-image-${groupId}`
      );

      // Update main container
      if (selectedFabricName) {
        if (fabricName.includes(" - ") && fabricName.includes(": ")) {
          const parts = fabricName.split(": ");
          const frameLabel = parts[0];
          const fabricAndGrade = parts[1];
          selectedFabricName.innerHTML = `<span class="label">${frameLabel}</span> <strong>${fabricAndGrade}</strong>`;
        } else {
          const nameParts = fabricName.split(": ");
          const grade = nameParts[0];
          const name = nameParts.length > 1 ? nameParts[1] : fabricName;
          selectedFabricName.innerHTML = `<span class="label">${grade}</span> <strong>${name}</strong>`;
        }
      }

      if (selectedFabricMaterial) {
        selectedFabricMaterial.innerHTML = fabricMaterial
          ? `${fabricMaterial}`
          : "";
      }

      if (selectedFabricImage) {
        // Remove any existing zoom state
        selectedFabricImage.classList.remove("zoomed");
        selectedFabricImage.style.cursor = "zoom-in";

        // Create and load new image
        const newImage = new Image();
        newImage.width = 600;
        newImage.alt = fabricName;

        newImage.onload = function () {
          selectedFabricImage.innerHTML = "";
          selectedFabricImage.appendChild(newImage);
          initZoomFunctionality(selectedFabricImage);
        };

        newImage.onerror = function () {
          console.error("Failed to load fabric image:", fabricImage);
          selectedFabricImage.innerHTML = `<div class="error">Image failed to load</div>`;
        };

        // Start loading the image
        newImage.src = fabricImage;
      }

      // Update sticky footer
      if (stickyFabricName) {
        if (fabricName.includes(" - ") && fabricName.includes(": ")) {
          const parts = fabricName.split(": ");
          const frameLabel = parts[0];
          const fabricAndGrade = parts[1];
          stickyFabricName.innerHTML = `<span class="label">${frameLabel}</span> <strong>${fabricAndGrade}</strong>`;
        } else {
          const nameParts = fabricName.split(": ");
          const grade = nameParts[0];
          const name = nameParts.length > 1 ? nameParts[1] : fabricName;
          stickyFabricName.innerHTML = `<span class="label">${grade}</span> <strong>${name}</strong>`;
        }
      }

      if (stickyFabricMaterial) {
        stickyFabricMaterial.innerHTML = fabricMaterial
          ? `${fabricMaterial}`
          : "";
      }

      if (stickyFabricImage) {
        // Remove any existing zoom state
        stickyFabricImage.classList.remove("zoomed");
        stickyFabricImage.style.cursor = "zoom-in";

        // Create and load new image for sticky footer
        const newStickyImage = new Image();
        newStickyImage.width = 400;
        newStickyImage.height = 400;
        newStickyImage.alt = fabricName;

        newStickyImage.onload = function () {
          stickyFabricImage.innerHTML = "";
          stickyFabricImage.appendChild(newStickyImage);
          initZoomFunctionality(stickyFabricImage);
        };

        newStickyImage.onerror = function () {
          console.error("Failed to load sticky fabric image:", fabricImage);
          stickyFabricImage.innerHTML = `<div class="error">Image failed to load</div>`;
        };

        // Start loading the image
        newStickyImage.src = fabricImage;
      }

      // Set fabric price
      setFabricPrice(groupId, fabricValue, productData);

      // Update selected state
      if (previousSelectedSwatch) {
        previousSelectedSwatch.classList.remove("selected");
      }
      this.classList.add("selected");
      previousSelectedSwatch = this;

      // Store the selected fabric value
      currentSelectedFabric = fabricValue;

      // Show sticky footer on mobile when fabric is selected
      const stickyFooter = document.querySelector(".sticky-footer");
      if (stickyFooter) {
        stickyFooter.classList.add("has-selection");
      }

      // Enable confirm buttons
      if (confirmBtn) {
        confirmBtn.disabled = false;
        confirmBtn.classList.add("animate");
        setTimeout(() => {
          confirmBtn.classList.remove("animate");
        }, 500);
      }

      // Enable sticky confirm button
      if (stickyConfirmBtn) {
        stickyConfirmBtn.disabled = false;
        stickyConfirmBtn.classList.add("animate");
        setTimeout(() => {
          stickyConfirmBtn.classList.remove("animate");
        }, 500);
      }
    });
  });

  // Close zoom when clicking outside
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".fabric__selected-image")) {
      const zoomedImages = document.querySelectorAll(
        ".fabric__selected-image.zoomed"
      );
      zoomedImages.forEach((img) => {
        img.classList.remove("zoomed");
        img.style.cursor = "zoom-in";
      });
    }
  });
}

async function fetchProductData(path) {
  try {
    const response = await fetch(path);

    // Check if the response is OK
    if (!response.ok) {
      console.warn(
        `Product data not available (${response.status}). Using embedded product data instead.`
      );
      return getEmbeddedProductData();
    }

    return await response.json();
  } catch (error) {
    return getEmbeddedProductData();
  }
}

function getEmbeddedProductData() {
  try {
    const productJsonScript = document.querySelector("script.product-json");
    if (productJsonScript && productJsonScript.textContent) {
      const productData = JSON.parse(productJsonScript.textContent);
      return { product: productData };
    }

    if (
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product
    ) {
      return { product: window.ShopifyAnalytics.meta.product };
    }

    console.error(
      "No product data available - cannot calculate prices or match variants"
    );
    return null;
  } catch (error) {
    return null;
  }
}

function setFabricPrice(groupId, fabricValue, productData) {
  const selectedFabricPrice = document.getElementById(
    `selected-fabric-price-${groupId}`
  );

  if (!selectedFabricPrice || !productData) return;

  try {
    // Get the currently selected fabric button to extract frame info
    const selectedFabricButton = document.querySelector(
      `.fabric-swatch-button[data-group="${groupId}"].selected`
    );
    const selectedFrame = selectedFabricButton
      ? selectedFabricButton.getAttribute("data-frame")
      : null;

    const incomingFabricName = fabricValue.split(" - ")?.[0];
    if (!incomingFabricName) {
      selectedFabricPrice.innerHTML = "";
      return;
    }

    const variant = productData.product.variants.find(function (variant) {
      // Check all option positions for fabric and frame matches
      let fabricMatches = false;
      let frameMatches = selectedFrame ? false : true;
      if (variant.option1) {
        const opt1Name = variant.option1.split(" - ")[0];
        if (opt1Name === incomingFabricName) fabricMatches = true;
        if (selectedFrame && opt1Name === selectedFrame) frameMatches = true;
      }

      if (variant.option2) {
        const opt2Name = variant.option2.split(" - ")[0];
        if (opt2Name === incomingFabricName) fabricMatches = true;
        if (selectedFrame && opt2Name === selectedFrame) frameMatches = true;
      }

      if (variant.option3) {
        const opt3Name = variant.option3.split(" - ")[0];
        if (opt3Name === incomingFabricName) fabricMatches = true;
        if (selectedFrame && opt3Name === selectedFrame) frameMatches = true;
      }

      return fabricMatches && frameMatches;
    });

    if (variant) {
      // Format price correctly (Shopify prices are in cents)
      const priceInPounds = (variant.price / 1).toFixed(2);
      selectedFabricPrice.innerHTML = `<span class="label">Price:</span> <strong>£${priceInPounds}</strong>`;
    } else {
      selectedFabricPrice.innerHTML = "";
    }
  } catch (error) {
    console.error("Error setting fabric price:", error);
    selectedFabricPrice.innerHTML = "";
  }
}

function setupFabricGroupData(groupId, dataContainers, fabricGroupsContainer) {
  if (!fabricGroupsContainer) return;

  // Clear the container
  fabricGroupsContainer.innerHTML = "";

  let hasFrameGroups = false;
  dataContainers.forEach((container) => {
    const frameGroups = container.querySelectorAll(".fabric-group[data-frame]");
    if (frameGroups.length > 0) {
      hasFrameGroups = true;
    }
  });

  if (hasFrameGroups) {
    const fabricsByFrame = {};

    dataContainers.forEach((container) => {
      const groups = container.querySelectorAll(".fabric-group[data-frame]");

      groups.forEach((group) => {
        const frame = group.getAttribute("data-frame");
        const description = group.getAttribute("data-description");

        if (!fabricsByFrame[frame]) {
          fabricsByFrame[frame] = { items: [], description: description };
        }

        const fabricDataElements = group.querySelectorAll(".fabric-data");
        fabricDataElements.forEach((fabricData) => {
          const fabric = {
            fabric: fabricData.getAttribute("data-fabric"),
            image: fabricData.getAttribute("data-image"),
            thumbnail: fabricData.getAttribute("data-thumbnail"),
            name: fabricData.getAttribute("data-name"),
            material: fabricData.getAttribute("data-material"),
            grade: fabricData.getAttribute("data-grade"),
            frame: fabricData.getAttribute("data-frame"),
          };

          fabricsByFrame[frame].items.push(fabric);
        });
      });
    });

    for (const [frame, data] of Object.entries(fabricsByFrame)) {
      if (!data.items || data.items.length === 0) continue;

      data.items.sort((a, b) => {
        const getNameForSorting = (fabric) => {
          const nameParts = fabric.name.split(": ");
          return nameParts.length > 1 ? nameParts[1] : fabric.name;
        };

        const nameA = getNameForSorting(a).toLowerCase();
        const nameB = getNameForSorting(b).toLowerCase();

        return nameA.localeCompare(nameB);
      });

      const sectionDiv = document.createElement("div");
      sectionDiv.className = "fabric__section";

      const titleDiv = document.createElement("div");
      titleDiv.className = "fabric__section-title";
      titleDiv.innerHTML = `<h3>${frame}</h3>${
        data.description ? `<p>${data.description}</p>` : ""
      }`;
      sectionDiv.appendChild(titleDiv);

      const fabricsList = document.createElement("ul");
      fabricsList.className = "fabric-list";

      data.items.forEach((fabric) => {
        const fabricItem = document.createElement("li");
        fabricItem.className = "fabric-item";

        const nameParts = fabric.name.split(": ");
        const grade = nameParts[0];
        const fabricName = nameParts.length > 1 ? nameParts[1] : fabric.name;

        const fullDisplayName = `${fabric.frame}: ${fabricName} - ${grade}`;
        const fabricDisplayName = fabricName;

        fabricItem.innerHTML = `
          <button type="button" class="fabric-swatch-button" data-group="${groupId}"
              data-fabric="${fabric.fabric}"
              data-image="${fabric.image}"
              data-name="${fullDisplayName}"
              data-material="${fabric.material}"
              data-frame="${fabric.frame}">
              <img src="${fabric.image}" width="300" height="300" alt="${fabricDisplayName}" loading="lazy">
              <div class="fabric-name">${fabricDisplayName}</div>
          </button>
        `;

        fabricsList.appendChild(fabricItem);
      });

      sectionDiv.appendChild(fabricsList);
      fabricGroupsContainer.appendChild(sectionDiv);
    }
  } else {
    const processedGrades = new Set();
    const fabricsByGrade = {
      "Grade B": { items: [] },
      "Grade C": { items: [] },
      AquaClean: { items: [] },
    };

    dataContainers.forEach((container) => {
      const groups = container.querySelectorAll(".fabric-group");

      groups.forEach((group) => {
        const grade = group.getAttribute("data-grade");
        const description = group.getAttribute("data-description");

        if (!processedGrades.has(grade)) {
          processedGrades.add(grade);
          fabricsByGrade[grade].description = description;
        }

        // Collect all fabric data elements
        const fabricDataElements = group.querySelectorAll(".fabric-data");
        fabricDataElements.forEach((fabricData) => {
          const fabric = {
            fabric: fabricData.getAttribute("data-fabric"),
            image: fabricData.getAttribute("data-image"),
            thumbnail: fabricData.getAttribute("data-thumbnail"),
            name: fabricData.getAttribute("data-name"),
            material: fabricData.getAttribute("data-material"),
            grade: fabricData.getAttribute("data-grade"),
          };

          fabricsByGrade[grade].items.push(fabric);
        });
      });
    });

    // Second pass: create HTML for each grade
    for (const [grade, data] of Object.entries(fabricsByGrade)) {
      if (!data.items || data.items.length === 0) continue;

      // Sort fabric items alphabetically by name within each grade
      data.items.sort((a, b) => {
        // Extract the fabric name (without grade prefix)
        const getNameForSorting = (fabric) => {
          const nameParts = fabric.name.split(": ");
          return nameParts.length > 1 ? nameParts[1] : fabric.name;
        };

        const nameA = getNameForSorting(a).toLowerCase();
        const nameB = getNameForSorting(b).toLowerCase();

        return nameA.localeCompare(nameB);
      });

      const sectionDiv = document.createElement("div");
      sectionDiv.className = "fabric__section";

      // Add section title
      const titleDiv = document.createElement("div");
      titleDiv.className = "fabric__section-title";
      titleDiv.innerHTML = `<h3>${grade}</h3><p>${data.description || ""}</p>`;
      sectionDiv.appendChild(titleDiv);

      // Add fabric list
      const fabricsList = document.createElement("ul");
      fabricsList.className = "fabric-list";

      data.items.forEach((fabric) => {
        const fabricItem = document.createElement("li");
        fabricItem.className = "fabric-item";

        // Get the fabric name without grade
        const nameParts = fabric.name.split(": ");
        const fabricDisplayName =
          nameParts.length > 1 ? nameParts[1] : fabric.name;

        fabricItem.innerHTML = `
          <button type="button" class="fabric-swatch-button" data-group="${groupId}"
              data-fabric="${fabric.fabric}"
              data-image="${fabric.image}"
              data-name="${fabric.name}"
              data-material="${fabric.material}">
              <img src="${fabric.image}" width="300" height="300" alt="${fabricDisplayName}" loading="lazy">
              <div class="fabric-name">${fabricDisplayName}</div>
          </button>
        `;

        fabricsList.appendChild(fabricItem);
      });

      sectionDiv.appendChild(fabricsList);
      fabricGroupsContainer.appendChild(sectionDiv);
    }
  }
}

function setupFabricSwatches(groupId, productData) {
  // Add click handlers to all fabric swatches for this group
  const fabricSwatches = document.querySelectorAll(
    `.fabric-swatch-button[data-group="${groupId}"]`
  );
  let previousSelectedSwatch = null;

  // Get the product data if not provided
  if (!productData) {
    fetchProductData(window.location.pathname + ".json")
      .then((data) => {
        productData = data;
      })
      .catch((error) => {
        console.error("Error loading product data:", error);
      });
  }

  fabricSwatches.forEach((swatch) => {
    swatch.addEventListener("click", function () {
      // Remove selected class from all swatches in this group
      fabricSwatches.forEach((s) => s.classList.remove("selected"));

      // Add selected class to clicked swatch
      this.classList.add("selected");

      if (previousSelectedSwatch) {
        previousSelectedSwatch.classList.remove("selected");
      }
      swatch.classList.add("selected");
      previousSelectedSwatch = swatch;

      // Get fabric data
      const fabricName = this.getAttribute("data-name");
      const fabricMaterial = this.getAttribute("data-material");
      const fabricImage = this.getAttribute("data-image");
      const fabricValue = this.getAttribute("data-fabric");

      // Update selected fabric display
      const selectedFabricName = document.getElementById(
        `selected-fabric-name-${groupId}`
      );
      const selectedFabricMaterial = document.getElementById(
        `selected-fabric-material-${groupId}`
      );
      const selectedFabricImage = document.getElementById(
        `selected-fabric-image-${groupId}`
      );
      const confirmButton = document.getElementById(
        `confirm-selection-${groupId}`
      );

      if (selectedFabricName) {
        // Parse the name to display properly
        if (fabricName.includes(" - ") && fabricName.includes(": ")) {
          const parts = fabricName.split(": ");
          const frameLabel = parts[0];
          const fabricAndGrade = parts[1];
          selectedFabricName.innerHTML = `<span class="label">${frameLabel}</span> <strong>${fabricAndGrade}</strong>`;
        } else {
          const nameParts = fabricName.split(": ");
          const grade = nameParts[0];
          const name = nameParts.length > 1 ? nameParts[1] : fabricName;
          selectedFabricName.innerHTML = `<span class="label">${grade}</span> <strong>${name}</strong>`;
        }
      }

      if (selectedFabricMaterial) {
        selectedFabricMaterial.innerHTML = fabricMaterial
          ? `${fabricMaterial}`
          : "";
      }

      if (selectedFabricImage) {
        // Reset zoom state when changing fabrics
        selectedFabricImage.classList.remove("zoomed");
        selectedFabricImage.innerHTML = `<img src="${fabricImage}" alt="${fabricName}" width="600" height="600">`;
      }

      // Set fabric price
      setFabricPrice(groupId, fabricValue, productData);

      // Enable confirm button and animate
      if (confirmButton) {
        confirmButton.disabled = false;
        confirmButton.classList.add("animate");
        setTimeout(() => {
          confirmButton.classList.remove("animate");
        }, 500);
      }
    });
  });
}

function filterFabricsByFrame(groupId, selectedFrame) {
  const fabricGroupsContainer = document.getElementById(
    `fabric-groups-container-${groupId}`
  );
  if (!fabricGroupsContainer) return;

  const fabricSections =
    fabricGroupsContainer.querySelectorAll(".fabric__section");

  if (!selectedFrame) {
    fabricSections.forEach((section) => {
      section.style.display = "";
    });
    return;
  }

  const selectedFrameName = selectedFrame.split(" - ")[0].trim();

  // Normalize frame names for comparison (handle HTML entities)
  const normalizeFrameName = (name) => {
    if (!name) return "";
    return name
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .trim();
  };
  const normalizedSelectedFrameName = normalizeFrameName(selectedFrameName);

  fabricSections.forEach((section) => {
    const sectionTitle = section.querySelector(".fabric__section-title h3");
    if (!sectionTitle) {
      section.style.display = "none";
      return;
    }

    const sectionFrame = sectionTitle.textContent.trim();
    const frameName = sectionFrame.split(" - ")[0].trim();
    const normalizedFrameName = normalizeFrameName(frameName);

    if (normalizedFrameName === normalizedSelectedFrameName) {
      section.style.display = "";
    } else {
      section.style.display = "none";
    }
  });
}

function getSelectedFrame() {
  const frameRadio = document.querySelector(
    'input[name="frame-selected"]:checked'
  );
  if (frameRadio) {
    return frameRadio.value;
  }

  const frameSelect = document.querySelector(
    'select.js-variant-selector[name*="Frame"]'
  );
  if (frameSelect && frameSelect.value) {
    return frameSelect.value;
  }

  return null;
}

function setupFabricTriggers(groupId, popup, productData) {
  const triggers = document.querySelectorAll(
    `[data-fabric-trigger="${groupId}"]`
  );

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      const selectedFrame = getSelectedFrame();
      filterFabricsByFrame(groupId, selectedFrame);
      popup.style.display = "block";
      document.body.style.overflow = "hidden";
      document.body.classList.add("fabric-popup-open");
      // Update preselected fabric based on selected frame
      updateFabricForSelectedFrame(groupId, selectedFrame, productData);
    });
  });

  const fabricDisplaySelects = document.querySelectorAll(
    ".fabric-display-select"
  );
  fabricDisplaySelects.forEach((trigger) => {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      const selectedFrame = getSelectedFrame();
      filterFabricsByFrame(groupId, selectedFrame);
      popup.style.display = "block";
      document.body.style.overflow = "hidden";
      document.body.classList.add("fabric-popup-open");
      updateFabricForSelectedFrame(groupId, selectedFrame, productData);
    });
  });

  // Also handle any legacy trigger with ID "view-fabrics-btn"
  const legacyTrigger = document.getElementById("view-fabrics-btn");
  if (legacyTrigger && groupId === "main") {
    legacyTrigger.setAttribute("data-fabric-trigger", groupId);
    legacyTrigger.addEventListener("click", function (e) {
      e.preventDefault();
      const selectedFrame = getSelectedFrame();
      filterFabricsByFrame(groupId, selectedFrame);
      popup.style.display = "block";
      document.body.style.overflow = "hidden"; // Disable scrolling
      document.body.classList.add("fabric-popup-open"); // Add body class
      updateFabricForSelectedFrame(groupId, selectedFrame, productData);
    });
  }
  const frameRadioButtons = document.querySelectorAll(
    'input[name="frame-selected"]'
  );
  frameRadioButtons.forEach((radio) => {
    radio.addEventListener("change", function () {
      const selectedFrame = getSelectedFrame();

      const frameSelect = document.querySelector(
        'select.js-variant-selector[name*="Frame"]'
      );
      if (frameSelect && selectedFrame) {
        const matchingOption = Array.from(frameSelect.options).find(
          (option) => {
            const optionValue = option.value;
            const optionValueDecoded = optionValue.replace(/&amp;/g, "&");
            const selectedFrameDecoded = selectedFrame.replace(/&amp;/g, "&");
            return (
              optionValue === selectedFrame ||
              optionValueDecoded === selectedFrameDecoded ||
              optionValue === selectedFrameDecoded ||
              optionValueDecoded === selectedFrame
            );
          }
        );

        if (matchingOption && frameSelect.value !== matchingOption.value) {
          frameSelect.value = matchingOption.value;
          const frameEvent = new Event("change", { bubbles: true });
          frameSelect.dispatchEvent(frameEvent);
        }
      }

      if (popup.style.display === "block") {
        filterFabricsByFrame(groupId, selectedFrame);
      }
      updateFabricForSelectedFrame(groupId, selectedFrame, productData);
    });
  });

  const frameSelect = document.querySelector(
    'select.js-variant-selector[name*="Frame"]'
  );
  if (frameSelect) {
    frameSelect.addEventListener("change", function () {
      const selectedFrame = getSelectedFrame();
      if (popup.style.display === "block") {
        filterFabricsByFrame(groupId, selectedFrame);
      }
      updateFabricForSelectedFrame(groupId, selectedFrame, productData);
    });
  }
}

function initZoomFunctionality(container) {
  if (!container) {
    return;
  }

  const image = container.querySelector("img");
  if (!image) {
    return;
  }

  // Remove any existing click listeners to prevent duplicates
  container.removeEventListener("click", handleZoomClick);

  // Set initial cursor state
  container.style.cursor = "zoom-in";

  // Add click handler
  container.addEventListener("click", handleZoomClick);
}

function handleZoomClick(e) {
  const container = e.currentTarget;
  const rect = container.getBoundingClientRect();
  const x = e.clientX - rect.left;
  const y = e.clientY - rect.top;

  // Calculate zoom origin as percentages
  const xPercent = ((x / rect.width) * 100).toFixed(2) + "%";
  const yPercent = ((y / rect.height) * 100).toFixed(2) + "%";

  // Toggle zoom class and set transform origin
  if (container.classList.contains("zoomed")) {
    container.classList.remove("zoomed");
    container.style.cursor = "zoom-in";
  } else {
    container.style.setProperty("--x", xPercent);
    container.style.setProperty("--y", yPercent);
    container.classList.add("zoomed");
    container.style.cursor = "zoom-out";
  }
}

// Function to handle fabric confirmation
function handleFabricConfirmation(
  groupId,
  currentSelectedFabric,
  popup,
  productData
) {
  if (!productData || !productData.product) {
    alert(
      "Unable to load product data. Please refresh the page and try again."
    );
    return;
  }

  if (currentSelectedFabric) {
    // Split the selected fabric at the dash and trim any whitespace
    const selectedFabricName = currentSelectedFabric.split(" - ")[0].trim();

    // Get the currently selected fabric element to extract frame info
    const selectedFabricButton = document.querySelector(
      `.fabric-swatch-button[data-group="${groupId}"].selected`
    );
    const selectedFrame = selectedFabricButton
      ? selectedFabricButton.getAttribute("data-frame")
      : null;

    // Get the select element for fabric
    const fabricSelect = document.querySelector(
      'select.js-variant-selector[name*="Fabric"], select.js-variant-selector[data-fabric-select="true"]'
    );

    const frameSelect = document.querySelector(
      'select.js-variant-selector[name*="Frame"]'
    );

    // Also get any fabric display divs
    const fabricDisplayDivs = document.querySelectorAll(
      ".fabric-display-select"
    );

    if (selectedFrame && frameSelect) {
      const matchingFrameOption = Array.from(frameSelect.options).find(
        (option) => {
          const optionFrameName = option.value.split(" - ")[0].trim();

          return optionFrameName === selectedFrame;
        }
      );

      if (matchingFrameOption) {
        frameSelect.value = matchingFrameOption.value;
        const frameEvent = new Event("change", { bubbles: true });
        frameSelect.dispatchEvent(frameEvent);
      }
    }

    if (fabricSelect) {
      // Find the option that matches the selected fabric name (ignoring text after the dash)
      const matchingOption = Array.from(fabricSelect.options).find((option) => {
        // Compare only the part before the dash in each option
        const optionFabricName = option.value.split(" - ")[0].trim();
        return optionFabricName === selectedFabricName;
      });

      if (matchingOption) {
        fabricSelect.value = matchingOption.value;
        // Dispatch change event
        const event = new Event("change", { bubbles: true });
        fabricSelect.dispatchEvent(event);

        // Update the fabric display selector text using the dedicated function
        updateFabricDisplaySelectorText(matchingOption.value, selectedFrame);

        if (productData && productData.product) {
          let matchingVariant = null;

          if (selectedFrame) {
            matchingVariant = productData.product.variants.find((variant) => {
              let variantFabricName = "";
              let variantFrameName = "";

              if (variant.option1) {
                const opt1Name = variant.option1.split(" - ")[0].trim();
                if (opt1Name === selectedFabricName) {
                  variantFabricName = opt1Name;
                }
                if (opt1Name === selectedFrame) {
                  variantFrameName = opt1Name;
                }
              }
              if (variant.option2) {
                const opt2Name = variant.option2.split(" - ")[0].trim();
                if (opt2Name === selectedFabricName) {
                  variantFabricName = opt2Name;
                }
                if (opt2Name === selectedFrame) {
                  variantFrameName = opt2Name;
                }
              }
              if (variant.option3) {
                const opt3Name = variant.option3.split(" - ")[0].trim();
                if (opt3Name === selectedFabricName) {
                  variantFabricName = opt3Name;
                }
                if (opt3Name === selectedFrame) {
                  variantFrameName = opt3Name;
                }
              }

              return (
                variantFabricName === selectedFabricName &&
                variantFrameName === selectedFrame
              );
            });
          } else {
            matchingVariant = productData.product.variants.find((variant) => {
              const variantFabricName = variant.option1
                ? variant.option1.split(" - ")[0].trim()
                : "";
              return variantFabricName === selectedFabricName;
            });
          }

          if (matchingVariant) {
            // Update all formVariantId elements with the correct variant ID
            const formVariantIds = document.querySelectorAll(".formVariantId");
            formVariantIds.forEach((input) => {
              input.setAttribute("name", "id");
              input.value = matchingVariant.id;
              input.dispatchEvent(new Event("change", { bubbles: true }));
            });

            // Trigger variant change event for cart drawer update
            if (window.Events) {
              window.Events.trigger("variantchange", matchingVariant);
            }
          }
        }

        // Get the fabric image data
        const fabricDataContainer = document.querySelector(
          `.fabric-data-container[data-group-id="${groupId}"]`
        );
        let fabricImage = "";
        if (fabricDataContainer) {
          const fabricDataElements =
            fabricDataContainer.querySelectorAll(".fabric-data");
          fabricDataElements.forEach((fabricData) => {
            const fabricValue = fabricData.getAttribute("data-fabric");
            if (fabricValue === currentSelectedFabric) {
              fabricImage = fabricData.getAttribute("data-image");
            }
          });
        }

        // Dispatch custom event for fabric selection
        let fullDisplayName = matchingOption.value;
        if (selectedFrame) {
          const fabricParts = matchingOption.value.split(" - ");
          const fabricName = fabricParts[0].trim();
          const grade = fabricParts[1] ? fabricParts[1].trim() : "";
          fullDisplayName = grade
            ? `${selectedFrame}: ${fabricName} - ${grade}`
            : `${selectedFrame}: ${fabricName}`;
        }

        const fabricSelectedEvent = new CustomEvent("fabricSelected", {
          detail: {
            fabricName: fullDisplayName,
            fabricImage: fabricImage,
            frameName: selectedFrame,
          },
        });
        document.dispatchEvent(fabricSelectedEvent);

        // Hide popup and enable scrolling
        popup.style.display = "none";
        document.body.style.overflow = "auto";
        document.body.classList.remove("fabric-popup-open"); // Remove body class
      }
    }
  }
}

function updateFabricForSelectedFrame(groupId, selectedFrame, productData) {
  if (!selectedFrame) return;

  const frameName = selectedFrame.split(" - ")[0].trim();

  const fabricSwatches = document.querySelectorAll(
    `.fabric-swatch-button[data-group="${groupId}"]`
  );

  const normalizeFrameName = (name) => {
    if (!name) return "";
    return name
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .trim();
  };
  const normalizedFrameName = normalizeFrameName(frameName);

  let firstMatchingSwatch = null;
  fabricSwatches.forEach((swatch) => {
    const swatchFrame = swatch.getAttribute("data-frame");
    const normalizedSwatchFrame = normalizeFrameName(swatchFrame);
    if (normalizedSwatchFrame === normalizedFrameName && !firstMatchingSwatch) {
      firstMatchingSwatch = swatch;
    }
  });

  if (firstMatchingSwatch) {
    fabricSwatches.forEach((s) => s.classList.remove("selected"));

    firstMatchingSwatch.classList.add("selected");

    const fabricName = firstMatchingSwatch.getAttribute("data-name");
    const fabricMaterial =
      firstMatchingSwatch.getAttribute("data-material") || "";
    const fabricImage = firstMatchingSwatch.getAttribute("data-image");
    const fabricValue = firstMatchingSwatch.getAttribute("data-fabric");

    updateFabricDisplay(
      groupId,
      fabricName,
      fabricMaterial,
      fabricImage,
      fabricValue
    );

    const fabricSelect = document.querySelector(
      'select.js-variant-selector[name*="Fabric"], select.js-variant-selector[data-fabric-select="true"]'
    );

    if (fabricSelect) {
      const fabricNamePart = fabricValue.split(" - ")[0].trim();
      const matchingOption = Array.from(fabricSelect.options).find((option) => {
        const optionFabricName = option.value.split(" - ")[0].trim();
        return optionFabricName === fabricNamePart;
      });

      if (matchingOption) {
        fabricSelect.value = matchingOption.value;
        const fabricEvent = new Event("change", { bubbles: true });
        fabricSelect.dispatchEvent(fabricEvent);

        // Use the option value from the select dropdown (which has the correct format)
        updateFabricDisplaySelectorText(matchingOption.value, selectedFrame);
      } else {
        // Fallback to fabricValue if no matching option found
        updateFabricDisplaySelectorText(fabricValue, selectedFrame);
      }
    } else {
      // Fallback if fabricSelect doesn't exist
      updateFabricDisplaySelectorText(fabricValue, selectedFrame);
    }

    const confirmBtn = document.getElementById(`confirm-selection-${groupId}`);
    const stickyConfirmBtn = document.getElementById(
      `sticky-confirm-selection-${groupId}`
    );

    if (confirmBtn) {
      confirmBtn.disabled = false;
    }
    if (stickyConfirmBtn) {
      stickyConfirmBtn.disabled = false;
    }

    const stickyFooter = document.querySelector(".sticky-footer");
    if (stickyFooter) {
      stickyFooter.classList.add("has-selection");
    }

    if (productData) {
      setFabricPrice(groupId, fabricValue, productData);
    } else {
      fetchProductData(window.location.pathname + ".json")
        .then((data) => {
          setFabricPrice(groupId, fabricValue, data);
        })
        .catch((error) => {
          console.error("Error loading product data for price:", error);
        });
    }
  }
}

function updateFabricDisplaySelectorText(fabricValue, selectedFrame) {
  const fabricDisplaySelects = document.querySelectorAll(
    ".fabric-display-select"
  );
  const fabricOptionElements = document.querySelectorAll(
    "[data-fabric-option-name]"
  );

  fabricDisplaySelects.forEach((displaySelect) => {
    const fabricOptionElement = displaySelect.querySelector(
      "[data-fabric-option-name]"
    );
    if (fabricOptionElement) {
      fabricOptionElement.setAttribute("data-fabric-option-name", fabricValue);

      const fabricParts = fabricValue.split(" - ");
      const fabricName = fabricParts[0].trim();
      const grade = fabricParts[1] ? fabricParts[1].trim() : "";

      const frameName = selectedFrame
        ? selectedFrame.split(" - ")[0].trim()
        : "";
      if (frameName) {
        if (grade) {
          fabricOptionElement.innerHTML = `<span class="label">${frameName}:</span>${fabricName} - ${grade}`;
        } else {
          fabricOptionElement.innerHTML = `<span class="label">${frameName}:</span>${fabricName}`;
        }
      } else {
        if (grade) {
          fabricOptionElement.textContent = `${fabricName} - ${grade}`;
        } else {
          fabricOptionElement.textContent = fabricName;
        }
      }
    }
  });
  fabricOptionElements.forEach((element) => {
    if (!element.closest(".fabric-display-select")) {
      element.setAttribute("data-fabric-option-name", fabricValue);

      const fabricParts = fabricValue.split(" - ");
      const fabricName = fabricParts[0].trim();
      const grade = fabricParts[1] ? fabricParts[1].trim() : "";

      const frameName = selectedFrame
        ? selectedFrame.split(" - ")[0].trim()
        : "";

      if (frameName) {
        if (grade) {
          element.innerHTML = `<span class="label">${frameName}:</span>${fabricName} - ${grade}`;
        } else {
          element.innerHTML = `<span class="label">${frameName}:</span>${fabricName}`;
        }
      } else {
        if (grade) {
          element.textContent = `${fabricName} - ${grade}`;
        } else {
          element.textContent = fabricName;
        }
      }
    }
  });
}

function checkAndSelectCurrentFabric(groupId) {
  const fabricSelect = document.querySelector(
    'select.js-variant-selector[name*="Fabric"], select.js-variant-selector[data-fabric-select="true"]'
  );
  if (!fabricSelect || !fabricSelect.value) return;

  const selectedFabricValue = fabricSelect.value;
  if (!selectedFabricValue) return;

  const fabricOptionNamePart = selectedFabricValue.split(" - ")[0].trim();

  const currentFrame = getSelectedFrame()
    ? getSelectedFrame().split(" - ")[0].trim()
    : null;

  // Get all fabric swatches for this group
  const fabricSwatches = document.querySelectorAll(
    `.fabric-swatch-button[data-group="${groupId}"]`
  );

  let matchedSwatch = null;

  fabricSwatches.forEach((swatch) => {
    const fabricData = swatch.getAttribute("data-fabric");
    if (!fabricData) return;

    // Split the fabric data by "-" and get the first part
    const fabricDataPart = fabricData.split(" - ")[0].trim();

    const swatchFrame = swatch.getAttribute("data-frame");

    const fabricMatches = fabricOptionNamePart === fabricDataPart;
    const frameMatches = currentFrame ? swatchFrame === currentFrame : true;

    if (fabricMatches && frameMatches && !matchedSwatch) {
      matchedSwatch = swatch;
      swatch.classList.add("selected");

      // Also update the current selected fabric variable
      const fabricName = swatch.getAttribute("data-name");
      const fabricMaterial = swatch.getAttribute("data-material") || "";
      const fabricImage = swatch.getAttribute("data-image");
      const fabricValue = swatch.getAttribute("data-fabric");

      // Update the display elements to show the selected fabric
      updateFabricDisplay(
        groupId,
        fabricName,
        fabricMaterial,
        fabricImage,
        fabricValue
      );

      // Enable confirm buttons
      const confirmBtn = document.getElementById(
        `confirm-selection-${groupId}`
      );
      const stickyConfirmBtn = document.getElementById(
        `sticky-confirm-selection-${groupId}`
      );

      if (confirmBtn) {
        confirmBtn.disabled = false;
      }
      if (stickyConfirmBtn) {
        stickyConfirmBtn.disabled = false;
      }

      // Show sticky footer on mobile when fabric is selected
      const stickyFooter = document.querySelector(".sticky-footer");
      if (stickyFooter) {
        stickyFooter.classList.add("has-selection");
      }
    }
  });
  if (matchedSwatch) {
    const selectedFabricName = matchedSwatch
      .getAttribute("data-fabric")
      .split(" - ")[0]
      .trim();
    const selectedFrame = matchedSwatch.getAttribute("data-frame");
    const fabricValue = matchedSwatch.getAttribute("data-fabric");
    const currentSelectedFrame = getSelectedFrame();

    const frameSelect = document.querySelector(
      'select.js-variant-selector[name*="Frame"]'
    );
    if (selectedFrame && frameSelect) {
      const matchingFrameOption = Array.from(frameSelect.options).find(
        (option) => {
          const optionFrameName = option.value.split(" - ")[0].trim();

          return optionFrameName === selectedFrame;
        }
      );

      if (matchingFrameOption) {
        frameSelect.value = matchingFrameOption.value;
        const frameEvent = new Event("change", { bubbles: true });
        frameSelect.dispatchEvent(frameEvent);
      }
    }
    const fabricSelect = document.querySelector(
      'select.js-variant-selector[name*="Fabric"], select.js-variant-selector[data-fabric-select="true"]'
    );

    if (fabricSelect && fabricSelect.value) {
      const actualSelectedValue = fabricSelect.value;
      const currentSelectedFrame = getSelectedFrame();
      updateFabricDisplaySelectorText(
        actualSelectedValue,
        currentSelectedFrame
      );
    } else if (currentSelectedFrame) {
      updateFabricDisplaySelectorText(fabricValue, currentSelectedFrame);
    }
  }
}

function updateFabricDisplay(
  groupId,
  fabricName,
  fabricMaterial,
  fabricImage,
  fabricValue
) {
  const selectedFabricName = document.getElementById(
    `selected-fabric-name-${groupId}`
  );
  const selectedFabricMaterial = document.getElementById(
    `selected-fabric-material-${groupId}`
  );
  const selectedFabricImage = document.getElementById(
    `selected-fabric-image-${groupId}`
  );
  const stickyFabricName = document.getElementById(
    `sticky-fabric-name-${groupId}`
  );
  const stickyFabricMaterial = document.getElementById(
    `sticky-fabric-material-${groupId}`
  );
  const stickyFabricImage = document.getElementById(
    `sticky-fabric-image-${groupId}`
  );

  // Update main container
  if (selectedFabricName) {
    if (fabricName.includes(" - ") && fabricName.includes(": ")) {
      const parts = fabricName.split(": ");
      const frameLabel = parts[0];
      const fabricAndGrade = parts[1];
      selectedFabricName.innerHTML = `<span class="label">${frameLabel}</span> <strong>${fabricAndGrade}</strong>`;
    } else {
      const nameParts = fabricName.split(": ");
      const grade = nameParts[0];
      const name = nameParts.length > 1 ? nameParts[1] : fabricName;
      selectedFabricName.innerHTML = `<span class="label">${grade}</span> <strong>${name}</strong>`;
    }
  }

  if (selectedFabricMaterial) {
    selectedFabricMaterial.innerHTML = fabricMaterial
      ? `${fabricMaterial}`
      : "";
  }

  if (selectedFabricImage) {
    // Remove any existing zoom state
    selectedFabricImage.classList.remove("zoomed");
    selectedFabricImage.style.cursor = "zoom-in";

    // Create and load new image
    const newImage = new Image();
    newImage.width = 600;
    newImage.alt = fabricName;

    newImage.onload = function () {
      selectedFabricImage.innerHTML = "";
      selectedFabricImage.appendChild(newImage);
      initZoomFunctionality(selectedFabricImage);
    };

    newImage.onerror = function () {
      console.error("Failed to load fabric image:", fabricImage);
      selectedFabricImage.innerHTML = `<div class="error">Image failed to load</div>`;
    };

    // Start loading the image
    newImage.src = fabricImage;
  }

  // Update sticky footer
  if (stickyFabricName) {
    if (fabricName.includes(" - ") && fabricName.includes(": ")) {
      const parts = fabricName.split(": ");
      const frameLabel = parts[0];
      const fabricAndGrade = parts[1];
      stickyFabricName.innerHTML = `<span class="label">${frameLabel}</span> <strong>${fabricAndGrade}</strong>`;
    } else {
      const nameParts = fabricName.split(": ");
      const grade = nameParts[0];
      const name = nameParts.length > 1 ? nameParts[1] : fabricName;
      stickyFabricName.innerHTML = `<span class="label">${grade}</span> <strong>${name}</strong>`;
    }
  }

  if (stickyFabricMaterial) {
    stickyFabricMaterial.innerHTML = fabricMaterial ? `${fabricMaterial}` : "";
  }

  if (stickyFabricImage) {
    // Remove any existing zoom state
    stickyFabricImage.classList.remove("zoomed");
    stickyFabricImage.style.cursor = "zoom-in";

    // Create and load new image for sticky footer
    const newStickyImage = new Image();
    newStickyImage.width = 400;
    newStickyImage.height = 400;
    newStickyImage.alt = fabricName;

    newStickyImage.onload = function () {
      stickyFabricImage.innerHTML = "";
      stickyFabricImage.appendChild(newStickyImage);
      initZoomFunctionality(stickyFabricImage);
    };

    newStickyImage.onerror = function () {
      console.error("Failed to load sticky fabric image:", fabricImage);
      stickyFabricImage.innerHTML = `<div class="error">Image failed to load</div>`;
    };

    // Start loading the image
    newStickyImage.src = fabricImage;
  }
}

// Initialize fabric display functionality
function initFabricDisplay() {
  function getFabricImage(fabricValue) {
    let fabricButton = document.querySelector(
      `button[data-fabric="${fabricValue}"]`
    );
    if (fabricButton) {
      return fabricButton.getAttribute("data-image");
    }

    const fabricName = fabricValue.split(" - ")[0];
    const fabricButtons = document.querySelectorAll("button[data-fabric]");

    for (let button of fabricButtons) {
      const buttonFabric = button.getAttribute("data-fabric");
      const buttonFabricName = buttonFabric.split(" - ")[0];
      if (buttonFabricName === fabricName) {
        return button.getAttribute("data-image");
      }
    }

    return "";
  }

  function initializeFirstFabricImage() {
    const fabricSelect = document.querySelector(
      'select[data-fabric-select="true"]'
    );
    const fabricImageElement = document.querySelector(
      '[id^="fabric-selected-img-"]'
    );

    if (fabricSelect && fabricImageElement) {
      const firstOption = fabricSelect.querySelector('option:not([value=""])');
      if (firstOption) {
        const firstFabricImage = getFabricImage(firstOption.value);
        if (firstFabricImage) {
          fabricImageElement.src = firstFabricImage;
          fabricImageElement.setAttribute("data-image", firstFabricImage);
          fabricImageElement.style.display = "block";
          return true;
        }
      }
    }
    return false;
  }

  function tryInitializeFabricDisplay() {
    const fabricSelect = document.querySelector(
      'select[data-fabric-select="true"]'
    );
    const fabricDisplayElement = document.querySelector(
      ".fabric-display-select"
    );
    const fabricImageElement = document.querySelector(
      '[id^="fabric-selected-img-"]'
    );

    if (fabricSelect && fabricDisplayElement && fabricImageElement) {
      let initialized = initializeFirstFabricImage();

      if (!initialized) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === "childList") {
              const fabricButtons = document.querySelectorAll(
                "button[data-fabric]"
              );
              if (fabricButtons.length > 0) {
                initializeFirstFabricImage();
                observer.disconnect();
              }
            }
          });
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      }

      fabricSelect.addEventListener("change", function () {
        if (this.value && this.value !== "") {
          if (fabricImageElement) {
            const fabricImage = getFabricImage(this.value);
            if (fabricImage) {
              fabricImageElement.src = fabricImage;
              fabricImageElement.setAttribute("data-image", fabricImage);
              fabricImageElement.style.display = "block";
            }
          }
          // Update the display text when fabric select changes
          const selectedFrame = getSelectedFrame();
          updateFabricDisplaySelectorText(this.value, selectedFrame);
        }
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryInitializeFabricDisplay);
  } else {
    tryInitializeFabricDisplay();
  }
}

// Initialize fabric display functionality
initFabricDisplay();
